import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import axiosMod from './modules/axios'
import dep from './modules/dep'
import toast from './modules/toast'
import permission from './modules/permission'
import apiService from './modules/apiService'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    dep,
    toast,
    permission,
    axiosMod,
    apiService,
  },
  devtool: 'source-map',
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: process.env.VUE_APP_URL + '/assets/app/img/sidebar-1.jpg',
    drawer: null,
    token: localStorage.getItem('access_token') || null,
    resetToken: localStorage.getItem('refresh_token') || null,
    nombreUsuario: (localStorage.getItem('user_name') || '') + ' ' + (localStorage.getItem('user_lastname') || ''),
    idUsuario: localStorage.getItem('user_is') || null,
    loader: 0,
    loaderIndex: 900,
    ToastColor: 'warning',
    ToastMessage: 'Empty',
    ToastShow: false,
    darkMode: (localStorage.getItem('dark_mode') !== undefined) ? localStorage.getItem('dark_mode') : true,
    UrlBase: process.env.VUE_APP_URL,
    aux: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    disableBtn: false,
  },
  getters: {
    loggedIn (state) {
      return state.token !== null && state.token !== undefined
    },
    getToken (state) {
      return state.token
    },
    getDarkMode (state) {
      return (state.darkMode === true || state.darkMode === 'true')
    },
    getLoggedId (state) {
      return state.idUsuario
    },
    getDisableBtn (state) {
      return state.disableBtn
    },
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    Set_darkMode (state, payload) {
      const tOf = (payload === 1 || payload === true)
      state.darkMode = tOf
      localStorage.setItem('dark_mode', tOf)
    },
    retrieveToken (state, token) {
      state.token = token
    },
    retriveRefreshToken (state, rToken) {
      state.resetToken = rToken
    },
    destroyToken (state) {
      state.token = null
    },
    setUserName (state, name) {
      state.nombreUsuario = name
    },
    setUserId (state, id) {
      state.idUsuario = id
      localStorage.setItem('user_is', id)
    },
    setDisableBtn (state, value) {
      state.disableBtn = value
    },
    ResetLoader (state) {
      state.loader = 0
    },
    loaderOn (state, payload) {
      state.loader += 1
      state.loaderIndex = payload
    },
    loaderOff (state) {
      state.loader -= 1
    },
    showMessage (state, payload) {
      state.ToastMessage = payload
      state.ToastShow = true
    },
  },
  actions: {
    destroyToken (context) {
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios.post('/api/logout', '', {
              headers: { Authorization: 'Bearer ' + context.state.token },
            })
            .then(response => {
              localStorage.removeItem('access_token')
              context.commit('destroyToken')
              resolve(response)
            })
            .catch(error => {
              localStorage.removeItem('access_token')
              context.commit('destroyToken')
              reject(error)
            })
        })
      }
    },
    retrieveToken (context, credentials) {
      return new Promise((resolve, reject) => {
        axios.post('/api/login', {
          username: credentials.username,
          password: credentials.password,
        })
          .then(response => {
            const token = response.data.oauth.access_token
            const refresh = response.data.oauth.refresh_token
            const name = response.data.user.name
            const lastname = response.data.user.lastname
            const permissions = response.data.permisos
            const id = response.data.user.id
            const dm = response.data.user.dark_mode_sn
            context.dispatch('permission/setPermissions', permissions)
            localStorage.setItem('access_token', token)
            localStorage.setItem('refresh_token', refresh)
            localStorage.setItem('user_name', name)
            localStorage.setItem('user_lastname', ((lastname !== null) ? lastname : ''))
            context.commit('Set_darkMode', dm)
            context.commit('retrieveToken', token)
            context.commit('setUserName', name + ' ' + ((lastname !== null) ? lastname : ''))
            context.commit('retriveRefreshToken', refresh)
            context.commit('setUserId', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchAccessToken (context) {
      const dat = {
        refresh_token: this.state.resetToken,
      }
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: '/api/refresh-token',
          data: {
            ...dat,
          },
          headers: { Authorization: 'Bearer ' + this.state.token },
        }).then(response => {
            const token = response.data.access_token
            const refresh = response.data.refresh_token
            localStorage.setItem('access_token', token)
            localStorage.setItem('refresh_token', refresh)
            context.commit('retrieveToken', token)
            context.commit('retriveRefreshToken', refresh)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    logout (context) {
      axios.post('/api/logout')
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      context.commit('destroyToken')
      router.push({ name: 'login' })
    },
  },
})
